import { Page, TitleConfig, DeviceSpecificSettings } from "../types/page";

// Initial pages state - only used if Supabase fetch fails
export const getInitialPages = (): Page[] => {
  return [
    {
      id: "1",
      title: "לימוד יומי",
      type: "daily-study",
      content: {
        chumash: "פרשת תזריע-מצורע",
        tehillim: "פרקים קמ״ה-ק״נ",
        tanya: "לקוטי אמרים, אמצע פרק מ״ג",
        hayomYom: "י״ט ניסן",
        rambam3: "הלכות חמץ ומצה, פרק ו-ח",
        rambam1: "הלכות תפילה, פרק י",
        seferHaMitzvot: "מצוות עשה קכ״ד-קכ״ח",
        lessons: []
      },
      enabled: true,
      order: 1,
    },
    {
      id: "2",
      title: "זמני תפילה",
      type: "prayer-times",
      content: {
        shacharit: "7:00",
        mincha: "19:15",
        maariv: "20:00",
        shabbatIn: "19:30",
        shabbatOut: "20:45",
      },
      enabled: true,
      order: 2,
    }
  ];
};

// Initial title config state - only used if Supabase fetch fails
export const getInitialTitleConfig = (): TitleConfig => {
  return {
    text: "לוח מידע",
    template: 'classic',
    showDate: true,
    showTime: true,
    showHebrewDate: true,
    dateFormat: "dd/MM/yyyy",
    timeFormat: "HH:mm",
    alignment: "center",
    dynamicPosition: "right",
    titleFontSize: "2.5rem",
    titleFontWeight: "bold",
    titleColor: "#ffffff",
    dateTimeFontSize: "1.5rem",
    dateTimeFontWeight: "normal",
    dateTimeColor: "#ffffff",
    subtitle: {
      enabled: false,
      showParasha: true,
      alignment: "center",
      fontSize: "medium"
    }
  };
};

// Initial device specific settings
export const getInitialDeviceSpecificSettings = (): DeviceSpecificSettings => {
  const initialTitleConfig = getInitialTitleConfig();
  const subtitleSettings = {
    enabled: false,
    showParasha: true,
    alignment: 'center' as const,
    fontSize: 'medium' as const
  };
  
  return {
    useSeparateConfigs: false,
    desktopTitleConfig: { 
      ...initialTitleConfig,
      subtitle: subtitleSettings
    },
    mobileTitleConfig: {
      ...initialTitleConfig,
      showHebrewDate: true,
      text: "לוח מידע",
      subtitle: subtitleSettings
    }
  };
};

// These functions are no longer used as primary sources since we now get values from Supabase
// But they're kept as fallbacks in case of connection issues
export const getInitialRotationInterval = (): number => {
  return 5;
};

export const getInitialAutoScroll = (): boolean => {
  return true;
};
